import { useEffect, useState } from "react"
import Table from "../../components/Table/Table"
import {
  GridCallbackDetails,
  GridColDef,
  GridRowsProp,
  GridSortModel,
} from "@mui/x-data-grid"
import { CustomerRepository } from "../../models/customer.model"
import { CustomerStatusChip } from "../Customers/CustomerStatusChip"

interface CustomerTableProps {
  customers: CustomerRepository[]
  isLoading: boolean
  pageInfo: any
  paginationModel: any
  setPaginationModel: React.Dispatch<React.SetStateAction<any>>
  sortModel?: GridSortModel | undefined
  onSortModelChange?:
    | ((model: GridSortModel, details: GridCallbackDetails) => void)
    | undefined
}

export const CustomerTable = ({
  customers,
  isLoading,
  pageInfo,
  paginationModel,
  setPaginationModel,
  sortModel,
  onSortModelChange,
}: CustomerTableProps) => {
  const [rowCountState, setRowCountState] = useState(
    pageInfo?.totalRowCount || 0,
  )

  useEffect(() => {
    setRowCountState((prevRowCountState: number) =>
      pageInfo?.totalRowCount !== undefined
        ? pageInfo?.totalRowCount
        : prevRowCountState,
    )
  }, [pageInfo?.totalRowCount, setRowCountState])

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "Customer ID",
      minWidth: 120,
      sortable: false,
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      minWidth: 180,
      flex: 1,
      sortable: false,
    },
    {
      field: "company",
      headerName: "Company",
      minWidth: 180,
      flex: 1,
      sortable: false,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 220,
      flex: 1,
      sortable: false,
    },
    {
      field: "panNo",
      headerName: "PAN No",
      minWidth: 140,
      sortable: false,
    },
    {
      field: "seats",
      headerName: "Seats",
      type: "number",
      minWidth: 100,
      sortable: false,
    },
    {
      field: "referenceNo",
      headerName: "Reference No",
      minWidth: 160,
      sortable: false,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 220,
      flex: 1,
      sortable: false,
    },
    {
      field: "payee",
      headerName: "Payee",
      minWidth: 160,
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      sortable: false,
      renderCell: ({ row }) => {
        return <CustomerStatusChip row={row} />
      },
    },
    {
      field: "source",
      headerName: "Source",
      minWidth: 130,
      sortable: false,
    },
  ]

  const rows: GridRowsProp = customers?.map((customer, index) => ({
    rowIndex: index,
    id: customer.customerId,
    customerName: customer.name,
    company: customer.company || "-",
    email: customer.email || "-",
    panNo: customer.panNo || "-",
    source: customer.source || "-",
    centreCode: customer.centreCode || "-",
    status: customer.status || "-",
    seats: customer.seats || "0",
    referenceNo: customer.referenceNo || "-",
    description: customer.description || "-",
    payee: customer.payee || "-",
  }))

  const columnVisibilityModel = {
    id: false,
    branch: false,
    balance: false,
    valueDate: false,
    paymentId: false,
  }

  return (
    <>
      <Table
        rows={rows}
        columns={columns}
        loading={isLoading}
        rowCount={rowCountState}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        disableColumnFilter
        columnVisibilityModel={columnVisibilityModel}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        disableRowSelectionOnClick
      />
    </>
  )
}
